import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import { ArrowCircleRightIcon } from '@heroicons/react/solid';
import ProjectModal from '../components/ProjectModal';
import Footer from '../layouts/Footer';
import ProductModal from '../components/productModal';

export default function Ducted() {
  const [t, i18n] = useTranslation('common');
  const [text, setText] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenSecond, setIsOpenSecond] = useState(false);
  const [title, setTitle] = useState('');
  const [image, setImage] = useState('');
  const [selectedButton, setSelectedButton] = useState('Button 1');
  const [description, setDescription] = useState('');
  const [desc, setDesc] = useState('');
  const [desc1, setDesc1] = useState('');
  const [desc2, setDesc2] = useState('');
  const [desc3, setDesc3] = useState('');
  const [desc4, setDesc4] = useState('');
  const [power, setPower] = useState('');
  const [heating, setHeating] = useState('');
  const [voltage, setVoltage] = useState('');
  const [flowRange, setFlowRange] = useState('');
  const [size, setSize] = useState('');
  const [href, setHref] = useState('');

  const handleButtonClick = (buttonText) => {
    setSelectedButton(buttonText);
    setText('');
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  const closeModalSecond = () => {
    setIsOpenSecond(false);
  };

  const data1 = [
    {
      id: 1,
      headTitle: '',
      title: `FXDQ-A`,
      image: '/FXDQ-A.png',
      description: `${t('welcome.A-Desc')}`,
      desc: `${t('welcome.A-D1')}`,
      desc1: `${t('welcome.A-D2')}`,
      desc2: `${t('welcome.A-D3')}`,
      desc3: `${t('welcome.A-D4')}`,
      desc4: `${t('welcome.A-D5')}`,
      // href: 'https://www.daikin.eu/en_us/products/product.table.html/FXDQ-A.html',
      headImage: '/FXDQ-A.png',
      power: ``,
      heating: `1.7-8.0 kW`,
      voltage: `220-240/220 V`,
      flowRange: ``,
      size: `750,950,1150x620x200 mm`,
    },
    {
      id: 2,
      headTitle: '',
      title: `FXDQ-M9`,
      image: '/FXDQ-M9.png',
      description: `${t('welcome.M9-Desc')}`,
      desc: `${t('welcome.M9-D1')}`,
      desc1: `${t('welcome.M9-D2')}`,
      desc2: `${t('welcome.M9-D3')}`,
      // href: 'https://www.daikin.eu/en_us/products/product.table.html/FXDQ-M9.html',
      headImage: '/FXDQ-M9.png',
      power: ``,
      heating: `2.2-3.2 kW`,
      voltage: `230 V`,
      flowRange: ``,
      size: `502x652x230 mm`,
    },
    {
      id: 3,
      headTitle: ``,
      title: `FXDQ-P3`,
      image: '/FXDQ-P3.png',
      description: `${t('welcome.P3-Desc')}`,
      desc: `${t('welcome.P3-D1')}`,
      desc1: `${t('welcome.P3-D2')}`,
      desc2: `${t('welcome.P3-D3')}`,
      desc3: `${t('welcome.P3-D4')}`,
      desc4: `${t('welcome.P3-D5')}`,
      // href: 'https://www.daikin.eu/en_us/products/product.table.html/FXDQ-P3.html',
      headImage: '/FXDQ-P3.png',
      power: ``,
      heating: `1.7-8.0 kW`,
      voltage: `220-240/220 V`,
      flowRange: ``,
      size: `750,950,1150x620x200 mm`,
    },
    // {
    //   id: 4,
    //   headTitle: '',
    //   title: `FDXM-F`,
    //   image: '/FDXM-F.png',
    //   description: `${t('welcome.F-Desc')}`,
    //   desc: `${t('welcome.F-D1')}`,
    //   desc1: `${t('welcome.F-D2')}`,
    //   desc2: `${t('welcome.F-D3')}`,
    //   desc3: `${t('welcome.F-D4')}`,
    //   desc4: `${t('welcome.F-D5')}`,
    //   href: 'https://www.daikin.eu/en_us/products/product.table.html/FDXM-F.html',
    //   headImage: '/FDXM-F.png',
    // },
    // {
    //   id: 5,
    //   headTitle: '',
    //   title: `FDXM-F9`,
    //   image: '/FDXM-F9.png',
    //   description: `${t('welcome.F9-Desc')}`,
    //   desc: `${t('welcome.F9-D1')}`,
    //   desc1: `${t('welcome.F9-D2')}`,
    //   desc2: `${t('welcome.F9-D3')}`,
    //   desc3: `${t('welcome.F9-D4')}`,
    //   href: 'https://www.daikin.eu/en_us/products/product.table.html/FDXM-F9.html',
    //   headImage: '/FDXM-F9.png',
    // },
    // {
    //   id: 6,
    //   headTitle: '',
    //   title: `FDXM-F3`,
    //   image: '/FDXM-F3.png',
    //   description: `${t('welcome.F3-Desc')}`,
    //   desc: `${t('welcome.F3-D1')}`,
    //   desc1: `${t('welcome.F3-D2')}`,
    //   desc2: `${t('welcome.F3-D3')}`,
    //   desc3: `${t('welcome.F3-D4')}`,
    //   href: 'https://www.daikin.eu/en_us/products/product.table.html/FDXM-F3.html',
    //   headImage: '/FDXM-F3.png',
    // },
  ];
  const data2 = [
    {
      id: 7,
      headTitle: '',
      title: `Ceiling Ducted (DC Low-height)`,
      image: '/Ceiling Ducted (DC Low-height).png',
      description: `${t('welcome.CDLowDesc')}`,
      desc: `${t('welcome.CDLowD1')}`,
      desc1: `${t('welcome.CDLowD2')}`,
      desc2: `${t('welcome.CDLowD3')}`,
      desc3: `${t('welcome.CDLowD4')}`,
      headImage: '/Ceiling Ducted (DC Low-height).png',
    },
    {
      id: 8,
      headTitle: '',
      title: `Ceiling Ducted (DC High Static Pressure)`,
      image: '/Ceiling Ducted (DC High Static Pressure).png',
      description: `${t('welcome.CDHighDesc')}`,
      desc: `${t('welcome.CDHighD1')}`,
      desc1: `${t('welcome.CDHighD2')}`,
      desc2: `${t('welcome.CDHighD3')}`,
      headImage: '/Ceiling Ducted (DC High Static Pressure).png',
    },
  ];

  const openModal = (id) => {
    if (id >= 0 && id < data1.length) {
      setTitle(data1[id].title);
      setDesc(data1[id].desc);
      setDesc1(data1[id].desc1);
      setDesc2(data1[id].desc2);
      setDesc3(data1[id].desc3);
      setDesc4(data1[id].desc4);
      setImage(data1[id].image);
      setDescription(data1[id].description);
      setHref(data1[id].href);
      setHeating(data1[id].heating);
      setSize(data1[id].size);
      setFlowRange(data1[id].flowRange);
      setVoltage(data1[id].voltage);
      setPower(data1[id].power);
      setIsOpen(true);
      console.log('true');
    }
  };
  const openModal2 = (id) => {
    if (id >= 0 && id < data2.length) {
      setTitle(data2[id].title);
      setDesc(data2[id].desc);
      setDesc1(data2[id].desc1);
      setDesc2(data2[id].desc2);
      setDesc3(data2[id].desc3);
      setDesc4(data2[id].desc4);
      setImage(data2[id].image);
      setDescription(data2[id].description);
      setHeating(data2[id].heating);
      setSize(data2[id].size);
      setFlowRange(data2[id].flowRange);
      setVoltage(data2[id].voltage);
      setPower(data2[id].power);
      setIsOpenSecond(true);
      console.log('true');
    }
  };

  return (
    <>
      <div className="h-fit w-full bg-white flex flex-col">
        <div className="flex justify-center items-center h-fit mt-10 mb-32 ">
          <div className="my-4 h-full xl:w-10/12 2xl:w-4/6 max-sm:w-10/12 max-xl:w-11/12">
            <div className="text-center h-full">
              <p className="text-6xl max-sm:text-3xl title-font font-extralight color-white mb-10 w-full">
                Ducted Air Conditioners
              </p>
              <div className="max-lg:hidden flex justify-center h-1/3 mb-2">
                <div className="flex justify-evenly items-center w-full h-full">
                  <NavLink
                    key="AirConditioning"
                    to="/AirConditioning"
                    className={`hover:bg-white shadow-lg rounded-tl-xl font-bold w-1/3 h-16 flex items-center justify-around flex-col bg-gray-50 text-white`}
                  >
                    <h1 className="text-indigo-900 text-xl title-font font-normal">AIR CONDITIONING</h1>
                  </NavLink>
                  <NavLink
                    key="Heating"
                    to="/Heating"
                    className={`hover:bg-white text-black shadow-lg hover:text-indigo-900 text-xl title-font font-normal font-bold w-1/3 h-16 flex items-center justify-around flex-col bg-gray-50 text-white`}
                  >
                    HEATING
                  </NavLink>
                  <NavLink
                    key="Ventilations"
                    to="/Ventilations"
                    className={`hover:bg-white text-black shadow-lg hover:text-indigo-900 text-xl title-font font-normal rounded-tr-xl font-bold w-1/3 h-16 flex items-center justify-around flex-col bg-gray-50 text-white`}
                  >
                    VENTILATIONS
                  </NavLink>
                </div>
              </div>
              <div className="max-lg:hidden flex justify-evenly h-full bg-cyan mb-12">
                <NavLink
                  key="WM"
                  to="/WallMounted"
                  className={`hover:bg-white font-bold w-1/3 h-16 flex items-center justify-center flex-col bg-gray-50 shadow-lg`}
                >
                  <h1 className="text-black hover:text-indigo-900 text-sm title-font font-normal">Wall Mounted</h1>
                </NavLink>
                <NavLink
                  key="MSS"
                  to="/MultiSplit"
                  className={`hover:bg-white font-bold w-1/3 h-16 flex items-center justify-center flex-col bg-gray-50 shadow-lg`}
                >
                  <h1 className="text-black hover:text-indigo-900 text-sm title-font font-normal">
                    Multi-Split Systems
                  </h1>
                </NavLink>
                <NavLink
                  key="CT"
                  to="/Cassette"
                  className={`hover:bg-white font-bold w-1/3 h-16 flex items-center justify-center flex-col bg-gray-50 shadow-lg`}
                >
                  <h1 className="text-black hover:text-indigo-900 text-sm title-font font-normal">Cassette Type</h1>
                </NavLink>
                <NavLink
                  key="FAC"
                  to="/FloorAir"
                  className={`hover:bg-white font-bold w-1/3 h-16 flex items-center justify-center flex-col bg-gray-50 shadow-lg`}
                >
                  <h1 className="text-black hover:text-indigo-900 text-sm title-font font-normal">
                    Floor Air Conditioners
                  </h1>
                </NavLink>
                <button
                  className={`hover:bg-white font-bold w-1/2 h-16 flex items-center justify-center flex-col bg-gray-50 shadow-lg`}
                >
                  <h1 className="text-indigo-900 text-lg title-font font-normal">Ducted Air Conditioners</h1>
                </button>
                <NavLink
                  key="Condensing"
                  to="/Condensing"
                  className={`hover:bg-white font-bold w-1/3 h-16 flex items-center justify-center flex-col bg-gray-50 shadow-lg`}
                >
                  <h1 className="text-black hover:text-indigo-900 text-sm title-font font-normal">Air Purifier</h1>
                </NavLink>
              </div>
              <div className="flex justify-start h-1/3 mb-4 w-full">
                <button
                  className={`hover:bg-white mr-3 font-bold w-1/5 max-lg:w-1/2 h-20 flex items-center justify-around flex-col ${
                    selectedButton === 'Button 1' ? ' shadow-xl bg-gray-50 text-white' : 'bg-white text-black'
                  }`}
                  onClick={() => handleButtonClick('Button 1')}
                >
                  <img className="w-2/3 h-2/3" src="daikin.png" alt="mrg" />
                </button>

                <button
                  className={`hover:bg-gray-50 mr-3 font-bold w-1/5 max-lg:w-1/2 h-20 flex items-center justify-around flex-col ${
                    selectedButton === 'Button 2' ? ' shadow-xl bg-gray-50 text-white' : 'bg-white text-black'
                  }`}
                  onClick={() => handleButtonClick('Button 2')}
                >
                  <img className="w-2/3 h-full fill-slate-600" src="hisense_.png" alt="mrg" />
                </button>
              </div>
              {selectedButton && (
                <>
                  {selectedButton === 'Button 1' && (
                    <div className="grid max-sm:grid-cols-1 max-xl:grid-cols-2 grid-cols-3 gap-2">
                      {data1.map((data1, i) => {
                        return (
                          <div
                            aria-hidden="true"
                            onClick={() => openModal(i)}
                            className="bg-gray-50 hover:bg-white border-r-2 border-b-2 w-full h-96 object-scale-down object-center scale-y-95 transition-all duration-400 hover:scale-100 shadow-md"
                          >
                            <div className="h-3/4 w-full">
                              <div className="relative h-full w-full">
                                <div className=" h-full w-full flex items-center justify-evenly ">
                                  <div className="w-full h-full flex items-center justify-center">
                                    <img
                                      src={data1.headImage}
                                      alt="mrg"
                                      className='w-full h-full bg-gray-50 hover:bg-white'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr className="solid" />
                            <div className="h-1/4 w-full flex items-center justify-center bg-white">
                              <div className="flex-1 p-5">
                                <h3 className="text-xl font-medium text-gray-700">{data1.title}</h3>
                                <button
                                  type="button"
                                  onClick={() => openModal(1)}
                                  className="mt-2 inline-flex text-sky-500"
                                >
                                  {t(`welcome.readMore`)} →
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {selectedButton === 'Button 2' && (
                    <div className="grid max-sm:grid-cols-1 max-xl:grid-cols-2 grid-cols-3 gap-2">
                      {data2.map((data2, i) => {
                        return (
                          <div
                            aria-hidden="true"
                            onClick={() => openModal2(i)}
                            className="bg-gray-50 hover:bg-white border-r-2 border-b-2 w-full h-96 object-scale-down object-center scale-y-95 transition-all duration-400 hover:scale-100 shadow-md"
                          >
                            <div className="h-3/4 w-full">
                              <div className="relative h-full w-full">
                                <div className=" h-full w-full flex items-center justify-evenly ">
                                  <div className="w-full h-full flex items-center justify-center">
                                    <img
                                      src={data2.headImage}
                                      alt="mrg"
                                      className="w-full h-full bg-gray-50 hover:bg-white"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr className="solid" />
                            <div className="h-1/4 w-full flex items-center justify-center bg-white">
                              <div className="flex-1 p-5">
                                <h3 className="text-xl font-medium text-gray-700">{data2.title}</h3>
                                <button
                                  type="button"
                                  onClick={() => openModal(1)}
                                  className="mt-2 inline-flex text-sky-500"
                                >
                                  {t(`welcome.readMore`)} →
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ProductModal
        title={title}
        show={isOpen}
        description={description}
        desc={desc}
        desc1={desc1}
        desc2={desc2}
        desc3={desc3}
        desc4={desc4}
        href={href}
        image={image}
        power={power}
        heating={heating}
        voltage={voltage}
        flowRange={flowRange}
        size={size}
        closeModal={closeModal}
      />
      <ProductModal
        // title={title}
        show={isOpenSecond}
        description={description}
        desc={desc}
        desc1={desc1}
        desc2={desc2}
        desc3={desc3}
        desc4={desc4}
        href={href}
        image={image}
        power={power}
        heating={heating}
        voltage={voltage}
        flowRange={flowRange}
        size={size}
        closeModal={closeModalSecond}
      />
    </>
  );
}
